

















































































































































import { defineComponent, ref, computed, reactive, watch, toRefs } from '@vue/composition-api';
import useSaveButton from '@/composables/buttons/useSaveButton';
import useCancelButton from '@/composables/buttons/useCancelButton';
import IMenu from '@/interfaces/IMenu';
import { useResult } from '@vue/apollo-composable';
import Sidebar from '@/components/Sidebar.vue';
import Button from '@/components/Button.vue';
import { useGetTemplatesQuery, useGetTemplateQuery, useGetStancodesQuery, Stancode } from '@/graphql/types';
import useVuelidate from '@vuelidate/core';
import { required, templateIdNumeric, templateIdRequired, withI18nMessage } from '@/utilities/validators';
import InputGroup from '@/components/InputGroup.vue';
import useCreateTemplateMutation from './composables/useCreateTemplateMutation';
import useUpdateTemplateMutation from './composables/useUpdateTemplateMutation';
import useDeleteTemplateMutation from './composables/useDeleteTemplateMutation';
import { helpers, maxLength } from '@vuelidate/validators';
import CommonHelper from '@/utilities/common.helper';
import Select2 from '@/components/Select2.vue';
import { S2Selection } from '@/types/s2selection';

export default defineComponent({
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: { Sidebar, Button, InputGroup, Select2 },
  setup(props, { root }) {
    const isNew = ref(props.id == null);
    const sc1187Selections: any = [];
    const sc1009Selections: any = [];
    const filteredSc1187Selections = ref([null as S2Selection<Stancode> | null]);
    const filteredSc1009Selections = ref([null as S2Selection<Stancode> | null]);
    const sc1187Stancodes = ref([] as Stancode[]);
    const sc1009Stancodes = ref([] as Stancode[]);

    const template = reactive({
      id: '',
      name: '',
      description: '',
      templateId: '',
      attributes: [
        {
          id: '',
          sc1187: null as S2Selection<Stancode> | null,
          sc1009: null as S2Selection<Stancode> | null,
          unit: '',
          name: '',
          sensorMapping: '',
          description: '',
          sc1187Id: '',
          sc1009Id: '',
          sc1187Touch: false,
          sc1009Touch: false,
          sensorMappingTouch: false,
          additionalDescriptionText: ''
        }
      ]
    });

    const stancodesQuery = useGetStancodesQuery({
      fetchPolicy: 'cache-and-network'
    });

    const templatesQuery = useGetTemplatesQuery({
      fetchPolicy: 'cache-and-network'
    });
    const stancodes = computed(() => stancodesQuery.result.value?.stancodes ?? []);
    const templates = computed(() => templatesQuery.result.value?.templates ?? []);

    const { result, loading } = useGetTemplateQuery(
      () => ({ id: props.id }),
      () => ({
        enabled: !isNew.value,
        fetchPolicy: 'network-only'
      })
    );

    const uniqueAttributeSensorMappingValidator = () => {
      const notEmptyAttributeSensorMappings = template.attributes.map(x => x.sensorMapping).filter(x => x);
      const uniqueAttributeSensorMappings = notEmptyAttributeSensorMappings.filter(CommonHelper.onlyUnique);
      return notEmptyAttributeSensorMappings.length === uniqueAttributeSensorMappings.length;
    };

    const v$ = useVuelidate(
      {
        ...useValidations(uniqueAttributeSensorMappingValidator)
      },
      { ...toRefs(template) },
      { $autoDirty: true }
    );

    const addNewAttribute = () => {
      template.attributes = Object.assign([], template.attributes);
      template.attributes.push({
        id: '',
        sc1187: null as S2Selection<Stancode> | null,
        sc1009: null as S2Selection<Stancode> | null,
        sensorMapping: '',
        description: '',
        sc1187Id: '',
        sc1009Id: '',
        name: '',
        unit: '',
        sc1187Touch: false,
        sc1009Touch: false,
        sensorMappingTouch: false,
        additionalDescriptionText: ''
      });
    };

    const removeAttributeAt = (index: number) => {
      template.attributes = Object.assign([], template.attributes);
      template.attributes.splice(index, 1);
    };

    const createMutation = useCreateTemplateMutation(template);
    createMutation.onDone(response => {
      root.$emit('refetchTemplates', response.data?.createTemplate);
      root.$router.back();
    });

    const updateMutation = useUpdateTemplateMutation(template);
    updateMutation.onDone(() => {
      root.$emit('refetchTemplates');
      root.$router.back();
    });

    const deleteMutation = useDeleteTemplateMutation(template);
    deleteMutation.onDone(() => {
      root.$emit('refetchTemplates');
      root.$router.back();
    });

    watch(
      () => stancodes.value,
      newValue => {
        if (newValue) {
          sc1187Stancodes.value = stancodes.value.filter(
            x => x.stancodeListId === '1343166a-0b5b-4472-a655-e2658b50d239' //1187
          );
          sc1187Stancodes.value
            .sort((a, b) => a.scCode - b.scCode)
            .forEach(element => {
              sc1187Selections?.push(new S2Selection<string>(element.id, GetStancodeText(element), element.id, null));
            });

          sc1009Stancodes.value = stancodes.value.filter(
            x => x.stancodeListId === '00fbef83-bba3-4991-9cc1-3c00697301d5' //1009
          );
          sc1009Stancodes.value
            .sort((a, b) => a.scCode - b.scCode)
            .forEach(element => {
              sc1009Selections?.push(new S2Selection<string>(element.id, GetStancodeText(element), element.id, null));
            });

          setFilteredStancodeSelections();
          assignTemplate(stancodes);
        }
      },
      { immediate: true }
    );

    watch(
      () => useResult(result).value,
      newValue => {
        assignTemplate(newValue);
      },
      { immediate: true, deep: true }
    );

    function assignTemplate(newValue: any) {
      if (!newValue || !stancodes) return;
      if (newValue) Object.assign(template, newValue);

      template.attributes = [
        ...template.attributes.map(attr => {
          var s1187 = stancodes.value.find(x => x.id === attr.sc1187Id);
          var s1009 = stancodes.value.find(x => x.id === attr.sc1009Id);
          return Object.assign(
            {},
            {
              id: attr.id,
              sc1187: s1187 ? new S2Selection<Stancode>(s1187!.id, s1187!.descriptionText ?? '', s1187!, null) : null,
              sc1009: s1009 ? new S2Selection<Stancode>(s1009!.id, s1009!.descriptionText ?? '', s1009!, null) : null,
              sensorMapping: attr.sensorMapping.trim(),
              description: s1187 ? String(s1187!.additionalDescriptionText) : '',
              sc1187Id: attr.sc1187Id,
              sc1009Id: attr.sc1009Id,
              name: attr.name,
              unit: attr.unit,
              sc1187Touch: false,
              sc1009Touch: false,
              sensorMappingTouch: false,
              additionalDescriptionText: s1187 ? String(s1187.additionalDescriptionText) : ''
            }
          );
        })
      ];

      v$.value.$reset();
    }

    function GetStancodeText(element: any) {
      return element.referenceTypeName !== 'Valid'
        ? `<p class='m-0 text-danger'>${element.scCode + ' - ' + element.descriptionText} ${GetValidity(
            element.referenceTypeName
          )}</p>`
        : element.scCode + ' - ' + element.descriptionText;
    }

    function GetValidity(text: string) {
      if (text === 'Obsolete') {
        return '(udgået)';
      }

      if (text === 'Temporary') {
        return '(midlertidig)';
      }

      if (text === 'reference') {
        return '(sammenlagt)';
      }

      return text;
    }

    function setFilteredStancodeSelections() {
      filteredSc1187Selections.value = [...sc1187Selections];
      filteredSc1009Selections.value = [...sc1009Selections];
    }

    const updateSc1187Touch = () => {
      template.attributes.forEach(x => (x.sc1187Touch = true));
    };

    const updateSc1009Touch = () => {
      template.attributes.forEach(x => (x.sc1009Touch = true));
    };

    const updateAttributeSensorTouch = () => {
      template.attributes.forEach(x => {
        x.sensorMappingTouch = false; //Refresh touch

        var text = x.sensorMapping.toLowerCase().trim();
        var duplicateValCount = template.attributes.filter(_ => _.sensorMapping.toLowerCase().trim() === text).length;
        if (!x.sensorMapping || duplicateValCount > 1) {
          x.sensorMappingTouch = true;
        }
      });
    };

    const validate = async () => {
      updateSc1187Touch();
      updateSc1009Touch();
      updateAttributeSensorTouch();
      return await v$.value.$validate();
    };

    return {
      isNew,
      loading: computed(
        () =>
          loading.value ||
          createMutation.loading.value ||
          updateMutation.loading.value ||
          deleteMutation.loading.value
      ),
      filteredSc1009Selections,
      filteredSc1187Selections,
      updateSc1187Touch,
      updateSc1009Touch,
      updateAttributeSensorTouch,
      ShowAdditionalInfo: function (index: number) {
        let obj = template.attributes.at(index);
        if (obj) {
          obj.additionalDescriptionText =
            stancodes.value.find(x => x.id == template.attributes.at(index)?.sc1187?.id)?.additionalDescriptionText ??
            '';
        }
      },
      template,
      v$,
      addNewAttribute,
      removeAttributeAt,
      primaryButton: isNew.value
        ? {
            ...useSaveButton(async () => {
              if (await validate()) createMutation.call();
            })
          }
        : {
            ...useSaveButton(async () => {
              if (await validate()) updateMutation.call();
            }),
            i18n: 'common.update'
          },
      secondaryButton: useCancelButton(() => root.$router.back()),
      menuItems: computed<IMenu[]>(() => [
        {
          name: root.$tc('common.delete'),
          icon: 'trash-alt',
          requireConfirmation: true,
          confirmationTitle: 'Slet skabelon',
          confirmationMessage: 'Vil du slette denne skabelon?',
          disabled: () => isNew.value,
          command: () => deleteMutation.call()
        }
      ])
    };
  }
});

function useValidations(uniqueAttributeSensorMappingValidator: () => boolean) {
  return {
    name: {
      required,
      maxLength: maxLength(512)
    },
    templateId: { templateIdRequired, templateIdNumeric },
    description: {},
    attributes: {
      uniqueAttributeSensorMapping: withI18nMessage(uniqueAttributeSensorMappingValidator),
      $each: helpers.forEach({
        sensorMapping: {
          required
        }
      })
    }
  };
}
